import ModelService from '../base/ModelService';

class Password extends ModelService {
  constructor() {
    super('password');
  }
}

export default new Password();
